import React, { useMemo } from 'react';
import { Segmented } from 'antd';
import { ModuleType } from 'infrastructure/enums';
import SegmentedLabel from 'components/organisms/oneplatform/patient-chart-activity/segmented-label';
import classNames from 'classnames';

import s from './styles.module.scss';

import type { SegmentedProps } from 'antd';

export interface IModuleTab {
  key: ModuleType;
}

interface IProps {
  activeKey?: ModuleType;
  rpmDisabled?: boolean;
  ccmDisabled?: boolean;
  apcmDisabled?: boolean;
  showApcm?: boolean;
  className?: string;
  onChange?: (tab: IModuleTab) => void;
}

const ModuleTabs: React.FC<IProps> = (props) => {
  const {
    activeKey,
    onChange,
    className,
    rpmDisabled = false,
    ccmDisabled = false,
    apcmDisabled = false,
    showApcm = false,
  } = props;

  const options = useMemo<SegmentedProps['options']>(() => {
    const allOptions = [
      {
        value: ModuleType.RPM,
        label: (
          <SegmentedLabel
            text={ModuleType.RPM}
            indicatorColor=""
            className={s.label}
          />
        ),
        disabled: rpmDisabled,
      },
      {
        value: ModuleType.CCM,
        label: (
          <SegmentedLabel
            text={ModuleType.CCM}
            indicatorColor=""
            className={s.label}
          />
        ),
        disabled: ccmDisabled,
      },
      {
        value: ModuleType.APCM,
        label: (
          <SegmentedLabel
            text={ModuleType.APCM}
            indicatorColor=""
            className={s.label}
          />
        ),
        disabled: apcmDisabled,
      },
    ];

    return showApcm ? allOptions : allOptions.slice(0, 2);
  }, [rpmDisabled, ccmDisabled, apcmDisabled, showApcm]);

  return (
    <Segmented
      options={options}
      value={activeKey}
      onChange={(value) => {
        if (onChange) {
          onChange({ key: value as ModuleType });
        }
      }}
      className={classNames(s.segmented, className)}
    />
  );
};

export default ModuleTabs;
